var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"chart"},[_c('div',{class:['chart-container', { loaded: _setup.chartRef }]},[_vm._t("default"),_c('canvas',{ref:"chartRef"})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }